import { NavigationItemModel } from '@stories/Widgets/Header/Header.types';
import * as React from 'react';
import { columnVisible, isActiveItem, linkVisible } from '../../../Header,helpers';
import DesktopNavigationDropdownLink from '../../DesktopNavigationDropdownLink/DesktopNavigationDropdownLink';
import S from '../ProductDropdown.styles';

export type VariantAProps = {
  levels: (NavigationItemModel[] | undefined)[][];
  activeItemId: string | null;
  onHover: (id: string) => void;
  translations: Record<string, string>;
};

const VariantA: React.FC<VariantAProps> = ({ levels, activeItemId, onHover, translations }) => {
  const columnRefs = React.useRef<(HTMLUListElement | null)[]>([]);

  React.useEffect(() => {
    // Check if active columns have a scrollbar, and set the data attribute accordingly
    columnRefs.current.forEach((ref) => {
      if (ref?.dataset.active === 'true') {
        const hasScrollbar = columnHasScrollbar(ref);
        ref.dataset.scrollbar = `${hasScrollbar}`;
      }
    });
  }, [activeItemId]);

  return (
    <>
      {levels.flat().map((level, i) =>
        level ? (
          <S.Column
            ref={(ref) => {
              if (ref) {
                columnRefs.current[i] = ref;
              }
            }}
            key={`level-${i + 3}`}
            data-active={columnVisible(level, activeItemId)}
            data-last-dropdown={!level.some((item) => item.children && item.children.length > 0)}
            onScroll={(event) => {
              // Check if scroll arrow should be shown, based on the scroll position
              const showScrollArrow = event.currentTarget.scrollTop > 0;
              event.currentTarget.dataset.scrollArrow = `${showScrollArrow}`;
            }}
          >
            {level &&
              level.map((item: NavigationItemModel) => {
                return (
                  <DesktopNavigationDropdownLink
                    key={item.id}
                    item={item}
                    active={isActiveItem(item.id, activeItemId)}
                    visible={linkVisible(item.id, activeItemId)}
                    dropdownLevel={`${item.id.split('/').length - 1}`}
                    onHover={(itemId) => onHover(itemId)}
                    translations={translations}
                  />
                );
              })}
          </S.Column>
        ) : null,
      )}
    </>
  );

  /**
   * @param columnRef Reference to the column element to check for scrollbar
   * @returns Value indicating if the column has a scrollbar
   */
  function columnHasScrollbar(columnRef: HTMLUListElement | null): boolean {
    // Get the scroll height of the column
    if (columnRef) {
      const columnScrollHeight = columnRef.scrollHeight;
      // Check if the scroll height exceeds 594 pixels
      return columnScrollHeight > 594;
    }
    return false;
  }
};

export default VariantA;
